import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/competing_interview_requests`

export const getCompetingInterviewRequests = async (hiringTeamId, candidate_profile_id) => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
    params: {
      candidate_profile_id,
    },
  })
  return response.data
}
